/**
 * Admin 게시판 CRUD. 라우트 admin.php boards 그룹과 동기화.
 * edit: 탭 전환 (게시판 수정 / 옵션 / 승인 / 태그 / 역할 관리)
 */
import { Logger } from "../../utils/Logger";

function noop(controller: string, action: string): void {
    Logger.debug(`${controller}.${action} (no-op)`);
}

function initBoardEditTabs(): void {
    const tabBtns = document.querySelectorAll(".admin-board-edit-tabs__tab");
    const panels = document.querySelectorAll(".admin-board-edit-panel");
    if (!tabBtns.length || !panels.length) return;

    tabBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
            const tabKey = btn.getAttribute("data-tab") ?? "";
            panels.forEach((p) => {
                const panelId = p.id ?? "";
                const isActive = panelId === "board-edit-panel-" + tabKey;
                (p as HTMLElement).classList.toggle("admin-board-edit-panel--hidden", !isActive);
            });
            tabBtns.forEach((b) => {
                const key = b.getAttribute("data-tab") ?? "";
                b.classList.toggle("admin-board-edit-tabs__tab--active", key === tabKey);
                b.setAttribute("aria-selected", key === tabKey ? "true" : "false");
            });
        });
    });
}

export const BoardController = {
    index(): void {
        noop("BoardController", "index");
    },
    create(): void {
        noop("BoardController", "create");
    },
    store(): void {
        noop("BoardController", "store");
    },
    edit(): void {
        initBoardEditTabs();
    },
    update(): void {
        noop("BoardController", "update");
    },
    destroy(): void {
        noop("BoardController", "destroy");
    },
};
